import React from 'react';

const Dashboard: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M7.5 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816
      2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V7.5C2.5 7.94203
      2.67559 8.36595 2.98816 8.67851C3.30072 8.99107 3.72464 9.16667
      4.16667 9.16667H7.5C7.94203 9.16667 8.36595 8.99107 8.67851
      8.67851C8.99107 8.36595 9.16667 7.94203 9.16667 7.5V4.16667C9.16667
      3.72464 8.99107 3.30072 8.67851 2.98816C8.36595 2.67559 7.94203 2.5
      7.5 2.5Z`} fill={props?.fill}/>
    <path d={`M7.5 10.834H4.16667C3.72464 10.834 3.30072 11.0096 2.98816
      11.3221C2.67559 11.6347 2.5 12.0586 2.5 12.5007V15.834C2.5 16.276
      2.67559 16.6999 2.98816 17.0125C3.30072 17.3251 3.72464 17.5007
      4.16667 17.5007H7.5C7.94203 17.5007 8.36595 17.3251 8.67851
      17.0125C8.99107 16.6999 9.16667 16.276 9.16667 15.834V12.5007C9.16667
      12.0586 8.99107 11.6347 8.67851 11.3221C8.36595 11.0096 7.94203 10.834
      7.5 10.834Z`} fill={props?.fill}/>
    <path d={`M15.8333 10.834H12.4999C12.0579 10.834 11.634 11.0096 11.3214
      11.3221C11.0088 11.6347 10.8333 12.0586 10.8333 12.5007V15.834C10.8333
      16.276 11.0088 16.6999 11.3214 17.0125C11.634 17.3251 12.0579 17.5007
      12.4999 17.5007H15.8333C16.2753 17.5007 16.6992 17.3251 17.0118
      17.0125C17.3243 16.6999 17.4999 16.276 17.4999 15.834V12.5007C17.4999
      12.0586 17.3243 11.6347 17.0118 11.3221C16.6992 11.0096 16.2753 10.834
      15.8333 10.834Z`} fill={props?.fill}/>
    <path d={`M14.1666 2.5C14.3707 2.50003 14.5678 2.57496 14.7203 2.7106C14.8728
      2.84623 14.9703 3.03312 14.9941 3.23583L15 3.33333V5H16.6666C16.879 5.00024
      17.0833 5.08157 17.2378 5.22737C17.3922 5.37318 17.4852 5.57246 17.4976
      5.7845C17.5101 5.99653 17.4411 6.20532 17.3048 6.36819C17.1684 6.53107
      16.9751 6.63575 16.7641 6.66083L16.6666 6.66667H15V8.33333C14.9997 8.54573
      14.9184 8.75003 14.7726 8.90447C14.6268 9.05892 14.4275 9.15186 14.2155
      9.16431C14.0034 9.17676 13.7947 9.10777 13.6318 8.97145C13.4689 8.83512
      13.3642 8.64175 13.3391 8.43083L13.3333 8.33333V6.66667H11.6666C11.4542
      6.66643 11.2499 6.5851 11.0955 6.43929C10.9411 6.29349 10.8481 6.09421
      10.8357 5.88217C10.8232 5.67014 10.8922 5.46135 11.0285 5.29847C11.1649
      5.1356 11.3582 5.03092 11.5691 5.00583L11.6666 5H13.3333V3.33333C13.3333
      3.11232 13.4211 2.90036 13.5774 2.74408C13.7337 2.5878 13.9456 2.5
      14.1666 2.5Z`} fill={props?.fill}/>
  </svg>
);

export default Dashboard;
